
import React from 'react';
import { HeroSection } from './components/HeroSection';
import { FeaturedEvent } from './components/FeaturedEvent';
import { UpcomingEvents } from './components/UpcomingEvents';
import { NewsSection } from './components/NewsSection';
import { SponsorsSection } from './components/SponsorsSection';
import { VolunteeringSection } from './components/VolunteeringSection';
import { NewsletterSignup } from './components/NewsletterSignup';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <FeaturedEvent />
      <UpcomingEvents />
      <NewsSection />
      <SponsorsSection />
      <VolunteeringSection />
      <NewsletterSignup />
    </div>
  );
};

export default HomePage;